module.exports = __webpack_public_path__ + "static/media/polygon-labeling.27bf4f58.gif";